import { render, staticRenderFns } from "./powerr.vue?vue&type=template&id=1133ede1&scoped=true&"
import script from "./powerr.vue?vue&type=script&lang=js&"
export * from "./powerr.vue?vue&type=script&lang=js&"
import style0 from "./powerr.vue?vue&type=style&index=0&id=1133ede1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133ede1",
  null
  
)

export default component.exports